import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import UIKIT from 'uikit';
import {useInput} from '../../../hook';
import {useFormData} from '../../../hook';
import {
  managerChangeOrderBasedStatusAction,
} from '../../../actions/order/action';
import {loadOrdersAction} from '../../../reducers/order';
import {loadCountsForSidenavAction} from '../../../reducers/analytics';

const ReturnOrderModal = ({openReturnOrderModal, setOpenReturnOrderModal, targetOrder}) => {
  const dispatch = useDispatch();

  const {
    updateManagerChangeOrderBasedStatusDone,
    updateManagerChangeOrderBasedStatusError,
    updateManagerChangeOrderBasedStatus,
  } = useSelector(state => state.order);

  const location = useLocation();

  const orderDetailReturnInfo = useFormData({});
  const isReturnDeliveryFee = useInput('0');
  const etcFee = useInput(0);

  const onSubmit = useCallback(
    e => {
      e.preventDefault();
      UIKIT.modal('#returnOrderModal').hide();
      setOpenReturnOrderModal(false);
      const formData = new FormData();
      formData.append('details', JSON.stringify(orderDetailReturnInfo.value));
      formData.append('detailStatus', 8);
      formData.append('_method', 'PUT');
      dispatch(managerChangeOrderBasedStatusAction(targetOrder.seq, formData));
    },
    [orderDetailReturnInfo],
  );

  useEffect(() => {
    if (openReturnOrderModal && targetOrder) {
      UIKIT.modal('#returnOrderModal').show();
      let orderDetailObject = {};
      for (let detail of targetOrder.detail) {
        if (!orderDetailObject[`detail_${detail.seq}`]) {
          orderDetailObject[`detail_${detail.seq}`] = {};
        }

        orderDetailObject[`detail_${detail.seq}`] = {isReturnDeliveryFee: '0', etcFee: 0, seq: detail.seq};
      }
      orderDetailReturnInfo.init(orderDetailObject);

      setOpenReturnOrderModal(false);
    }
  }, [openReturnOrderModal, targetOrder]);


  return (
    <div id="returnOrderModal" className="uk-position-z-index-9999999" data-uk-modal="container:false;">
      <div className="uk-modal-dialog">
        <button className="uk-modal-close-default" type="button" data-uk-close></button>
        <div className="uk-modal-body uk-padding-remove-horizontal uk-padding-horizontal@m">
          <div className="uk-text-0_9 uk-grid-divider" data-uk-grid>
            <div className="uk-width-1-1 uk-width-1-1@m">
              <form onSubmit={onSubmit}>
                {orderDetailReturnInfo &&
                  targetOrder &&
                  targetOrder.detail.map(detail => (
                    <div key={detail.seq}>
                      <div className="uk-margin">
                        <div>
                          <span>
                            {targetOrder.name} {detail.option_name}
                          </span>
                        </div>
                        <div className="uk-margin-small-top">
                          <div className="uk-background-muted uk-padding-small">
                            <h5 className="uk-text-bold uk-margin-small-bottom">반품 비용 결제방법</h5>
                            <div className="uk-margin-small">
                              <span className="uk-text-primary uk-text-bold">
                                {detail.returnInfo?.claimDeliveryFeePayMethod}
                              </span>
                            </div>
                            {['판매자에게 직접 송금', '판매자에게 직접 송금하거나 상품에 동봉'].includes(
                              detail.returnInfo?.claimDeliveryFeePayMethod,
                            ) && (
                              <div className="uk-text-danger uk-text-small uk-margin-small-top">
                                * 반품비용 입금 확인 후 처리를 진행해주세요.
                              </div>
                            )}
                            {['지금결제-추가결제', '환불금에서 차감', '지금 결제함-추가결제', '환불금 차감'].includes(
                              detail.returnInfo?.claimDeliveryFeePayMethod,
                            ) && (
                              <div className="uk-text-success uk-text-small uk-margin-small-top">
                                * 자동으로 환불금에서 차감되어 처리됩니다.
                              </div>
                            )}
                            {![
                              '판매자에게 직접 송금',
                              '판매자에게 직접 송금하거나 상품에 동봉',
                              '지금결제-추가결제',
                              '환불금에서 차감',
                              '지금 결제함-추가결제',
                              '환불금 차감',
                            ].includes(detail.returnInfo?.claimDeliveryFeePayMethod) && (
                              <div className="uk-text-muted uk-text-small uk-margin-small-top">
                                * 해당 결제 방식에 대한 별도의 안내 내용이 없습니다. 관리자에게 문의해주세요.
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="uk-form-label uk-flex uk-flex-middle">
                          <span>반품 배송비 결제 여부</span>
                          <i
                            className="mdi mdi-help-circle-outline uk-margin-xsmall-left uk-text-muted uk-pointer"
                            style={{fontSize: '1em'}}
                            data-uk-tooltip="title: 예 : 배송비 동봉, 선결제<br/>아니오 : 반품 배송비 자동 차감; pos: top-left"
                          ></i>
                        </div>
                        <div className="uk-form-controls">
                          <label className="uk-margin-small-right">
                            <input
                              className="uk-radio"
                              type="radio"
                              name={`detail_${detail.seq}.isReturnDeliveryFee`}
                              value={'1'}
                              onChange={orderDetailReturnInfo.onChange}
                              checked={
                                (orderDetailReturnInfo.value[`detail_${detail.seq}`] &&
                                  orderDetailReturnInfo.value[`detail_${detail.seq}`].isReturnDeliveryFee) === '1'
                                  ? true
                                  : false
                              }
                            />{' '}
                            예
                          </label>
                          <label>
                            <input
                              className="uk-radio"
                              type="radio"
                              name={`detail_${detail.seq}.isReturnDeliveryFee`}
                              value={'0'}
                              onChange={orderDetailReturnInfo.onChange}
                              checked={
                                (orderDetailReturnInfo.value[`detail_${detail.seq}`] &&
                                  orderDetailReturnInfo.value[`detail_${detail.seq}`].isReturnDeliveryFee) === '0'
                                  ? true
                                  : false
                              }
                            />{' '}
                            아니오
                          </label>
                        </div>
                      </div>
                      <div className="uk-margin">
                        <label className="uk-form-label" htmlFor={`detail_${detail.seq}.etcFee`}>
                          기타청구금액
                        </label>
                        <div className="uk-form-controls">
                          <div className="uk-inline uk-width-1-1">
                            <span className="uk-form-icon uk-form-icon-flip" style={{fontSize: '0.9rem'}}>
                              원
                            </span>
                            <input
                              className="uk-input uk-text-right"
                              name={`detail_${detail.seq}.etcFee`}
                              id={`detail_${detail.seq}.etcFee`}
                              type="text"
                              placeholder="0"
                              value={
                                orderDetailReturnInfo.value[`detail_${detail.seq}`] &&
                                orderDetailReturnInfo.value[`detail_${detail.seq}`].etcFee
                                  ? orderDetailReturnInfo.value[`detail_${detail.seq}`].etcFee.toLocaleString()
                                  : 0
                              }
                              onChange={orderDetailReturnInfo.onChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                <div className="uk-margin-medium-top uk-text-right">
                  <button className="uk-button uk-button-default uk-modal-close uk-margin-small-right" type="button">
                    취소
                  </button>
                  <button className="uk-button uk-button-primary" type="submit">
                    반품확인 처리
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnOrderModal;
